const GridCustomCheckBoxRow = (props) => {

    // Armazena os ids selecionados.
    const { setSelectedRows, row, hiddenChecked, singleSelect } = props;

    const checkboxFun = () => {
        setTimeout(() => {
            const checkbox = document.querySelectorAll('.item-history input');
            let selectedRows = [];

            for (let i = 0; i < checkbox.length; i++) {
                const element = checkbox[i]
                if (element.checked) {
                    selectedRows.push(Number(element.value));
                }
            }

            setSelectedRows(selectedRows);
        }, 200);
    }

    const radioFun = (id) => {
        // Para radio, sempre seleciona apenas um item
        setSelectedRows([Number(id)]);
    }

    return (
        <td className='item-history'>
            <div className="form-check">
                {
                    row.createdAt === null || (hiddenChecked !== undefined && hiddenChecked)?
                        <></>
                        :
                        <input 
                            className="form-check-input" 
                            type={singleSelect ? "radio" : "checkbox"}
                            name={singleSelect ? "grid-select" : undefined}
                            value={row.id} 
                            onClick={() => singleSelect ? radioFun(row.id) : checkboxFun()} 
                        />
                }
            </div>
        </td>
    )
}

export default GridCustomCheckBoxRow;